import { useState } from 'react';
import { loginAdmin } from '../services/api';

export default function AdminLogin({ onLoginSuccess, onExit }) {
  const [form, setForm]       = useState({ username:'', password:'' });
  const [errors, setErrors]   = useState({});
  const [loading, setLoading] = useState(false);
  const set = (k,v) => { setForm(f=>({...f,[k]:v})); setErrors(e=>({...e,[k]:'',form:''})); };

  const handleLogin = async () => {
    const e = {};
    if (!form.username.trim()) e.username = 'Required';
    if (!form.password) e.password = 'Required';
    if (Object.keys(e).length) { setErrors(e); return; }
    setLoading(true);
    try {
      const data = await loginAdmin(form.username, form.password);
      if (data.token) { sessionStorage.setItem('token', data.token); }
      onLoginSuccess();
    } catch(err) { setErrors({ form: err.message||'Invalid credentials.' }); } finally { setLoading(false); }
  };

  return (
    <div style={{ background:'linear-gradient(135deg,#0066cc 0%,#0052a3 100%)', minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'white', borderRadius:16, padding:'44px 40px', maxWidth:420, width:'100%', boxShadow:'0 20px 60px rgba(0,0,0,0.25)' }}>
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ width:72, height:72, background:'var(--primary-light)', borderRadius:16, fontSize:36, display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 18px' }}>?</div>
          <h1 style={{ fontSize:24, fontWeight:800, margin:'0 0 6px' }}>Admin Access</h1>
          <p style={{ color:'var(--text-light)', fontSize:13, margin:0 }}>Authorised personnel only</p>
        </div>
        {errors.form && <div style={{ background:'#fee2e2', border:'1px solid #fca5a5', borderRadius:8, padding:'10px 14px', marginBottom:20, fontSize:13, color:'#7f1d1d', fontWeight:600 }}> {errors.form}</div>}
        <div style={{ marginBottom:16 }}>
          <label style={{ display:'block', fontSize:13, fontWeight:700, marginBottom:7, textTransform:'uppercase', letterSpacing:'0.5px' }}>Email</label>
          <input type="text" value={form.username} onChange={e=>set('username',e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleLogin()} placeholder="admin@socialprotection.go.ke"
            style={{ width:'100%', padding:'12px 14px', border:'1.5px solid var(--border-light)', borderRadius:8, fontSize:14, boxSizing:'border-box' }}/>
          {errors.username && <p style={{ color:'var(--danger-color)', fontSize:12, margin:'5px 0 0' }}>{errors.username}</p>}
        </div>
        <div style={{ marginBottom:28 }}>
          <label style={{ display:'block', fontSize:13, fontWeight:700, marginBottom:7, textTransform:'uppercase', letterSpacing:'0.5px' }}>Password</label>
          <input type="password" value={form.password} onChange={e=>set('password',e.target.value)} onKeyDown={e=>e.key==='Enter'&&handleLogin()} placeholder="Enter password"
            style={{ width:'100%', padding:'12px 14px', border:'1.5px solid var(--border-light)', borderRadius:8, fontSize:14, boxSizing:'border-box' }}/>
          {errors.password && <p style={{ color:'var(--danger-color)', fontSize:12, margin:'5px 0 0' }}>{errors.password}</p>}
        </div>
        <button onClick={handleLogin} disabled={loading} style={{ width:'100%', padding:14, background:loading?'var(--text-light)':'linear-gradient(135deg,var(--primary-color),#0052a3)', color:'white', border:'none', borderRadius:8, fontSize:15, fontWeight:700, cursor:loading?'default':'pointer', marginBottom:12 }}>
          {loading?'Signing in...':'Sign In'}
        </button>
        <button onClick={onExit} style={{ width:'100%', padding:13, background:'var(--bg-light)', color:'var(--text-secondary)', border:'1px solid var(--border-light)', borderRadius:8, fontSize:14, fontWeight:600, cursor:'pointer' }}>Back to Main Site</button>
      </div>
    </div>
  );
}








